var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatorio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.25H8.05L10.75 3.95V13.25H3.5V1.25Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05 1.25V3.95H10.75",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6H8.95",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8H8.95",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10H7.1",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15 10.1L9.05 11L10.75 9.2",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatorio);
export default __webpack_public_path__ + "static/media/regulatorio.875ac6b2f6460c3e5a7ab8aeac2da4b4.svg";
export { ForwardRef as ReactComponent };